import React from "react";
import PropTypes from "prop-types";
import { FormControl, Select, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

function ProjectFilter({ status, setStatus }) {
  return (
    <Grid container justifyContent="flex-end" pb={2}>
      <Grid item xs={12} sm={4} md={3}>
        <Autocomplete
          disablePortal
          id="project-filter"
          options={["All", "Approved", "Rejected", "Pending"]}
          value={status || ""}
          sx={{ width: "100%" }}
          onChange={(_, value) => setStatus(value)}
          renderInput={(params) => <TextField {...params} placeholder="Select Filter" />}
          isOptionEqualToValue={(option, value) => option === value}
        />
      </Grid>
    </Grid>
  );
}

ProjectFilter.propTypes = {
  status: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default ProjectFilter;
